import { store } from "../store";
import { call, put, takeLatest } from "redux-saga/effects";
import ENV from "../config/env";
import axiosInstance from "../../api/axiosInstance";
import {
  GET_ACCOMPLISHMENTS_DETAILS_REQUEST,
  GET_CANDIDATE_ADDRESS_DETAILS_REQUEST,
  GET_CANDIDATE_INFO_DETAILS_REQUEST,
  GET_CANDIDATE_JOB_PROFILE_REQUEST,
  GET_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST,
  GET_CANDIDATE_LISINCE_DETAILS_REQUEST,
  GET_CANDIDATE_SIDE_BAR_REQUEST,
  GET_DEGREE_TYPE_DROPDOWN_DETAILS_REQUEST,
  GET_DESIGNATION_DROPDOWN_REQUEST,
  GET_DOC_DETAILS_REQUEST,
  GET_EDUCATION_ACTIVE_REQUEST,
  GET_EDUCATION_DETAILS_REQUEST,
  GET_JOB_PERF_DETAILS_REQUEST,
  GET_LANGAUGE_DROPDOWN_DETAILS_REQUEST,
  GET_LINCE_ACTIVE_REQUEST,
  GET_NON_HOSPITAL_DROPDOWN_REQUEST,
  GET_WORK_EXPRINCE_ACTIVE_REQUEST,
  GET_WORK_EXPRINCE_DETAILS_REQUEST,
  SAVE_ACCOMPLISHMENTS_DETAILS_REQUEST,
  SAVE_CANDIDATE_ADDRESS_DETAILS_REQUEST,
  SAVE_CANDIDATE_INFO_DETAILS_REQUEST,
  SAVE_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST,
  SAVE_CANDIDATE_LISINCE_DETAILS_REQUEST,
  SAVE_DOC_DETAILS_REQUEST,
  SAVE_EDUCATION_DETAILS_REQUEST,
  SAVE_JOB_PERF_DETAILS_REQUEST,
  SAVE_WORK_EXPRINCE_DETAILS_REQUEST,
} from "./type";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}
function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function* languageDropdownSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/LanguagesDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCandidatePersonalInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidatePersonalInfo?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveCandidatePersonalInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidatePersonalInfo`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCandidateAddressInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateAddressDetails?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveCandidateAddressInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateAddressDetails`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCandidateKeySkillsInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateKeySkills?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveCandidateKeySkillsInfoSaga(action) {
  const {
    payload: { user, payload },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateKeySkills?candidateId=${user}`,
      payload, // ✅ now correct
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCandidateCertificationInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateCertificationAndLicensing?candidateId=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCandidateSideBarSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateStagingProgressAndProfileCompletionDetails?candidateId=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveCandidateCertificationInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateCertificationAndLicensing/V1`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getEducationInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateEducationDetails?candidateId=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveEducationInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateEducationDetails`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getAccomplishInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateAccomplishments?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* saveAccomplishInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateAccomplishments`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* degreeTypeDropdownSaga(action) {
  const { payload, callback } = action;
  const profession =
    payload?.profession || store.getState()?.auth?.user?.candidateProfession;
  const professionQuery = profession
    ? `?profession=${encodeURIComponent(profession)}`
    : "";
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/DegreeTypeDropdown${professionQuery}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getDocInfoSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateDocInfo?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* saveDocInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateDocInfo`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* nonHospitalRolesDropdownSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/NonHospitalRolesDropdown`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCandidateJobPreferencesSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateJobPreferences?candidateId=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* saveCandidateJobPreferencesSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateJobPreferences`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateEducationActiveSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/update/CandidateEducationActiveFlag?id=${user}&active=False`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getWorkExprinceActiveSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/update/CandidateWorkExperienceActiveFlag?id=${user}&active=false`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* candidateCertificationAndLicensingActiveSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/update/CandidateCertificationAndLicensingActiveFlag?id=${user}&active=False`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* designationDropdownSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/DesignationDropdown`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getWorkExprinceSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateWorkExperience?candidateId=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* saveWorkExprinceSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateWorkExperience`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateProfileJobSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/get/CandidateDetailsForProfile?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* candidateFlowWatcherSaga() {
  yield takeLatest(
    GET_LINCE_ACTIVE_REQUEST,
    candidateCertificationAndLicensingActiveSaga,
  );
  
    yield takeLatest(GET_CANDIDATE_JOB_PROFILE_REQUEST, candidateProfileJobSaga);
  yield takeLatest(GET_WORK_EXPRINCE_ACTIVE_REQUEST, getWorkExprinceActiveSaga);
  yield takeLatest(GET_EDUCATION_ACTIVE_REQUEST, candidateEducationActiveSaga);

  yield takeLatest(GET_WORK_EXPRINCE_DETAILS_REQUEST, getWorkExprinceSaga);
  yield takeLatest(SAVE_WORK_EXPRINCE_DETAILS_REQUEST, saveWorkExprinceSaga);
  yield takeLatest(GET_DESIGNATION_DROPDOWN_REQUEST, designationDropdownSaga);

  yield takeLatest(
    GET_JOB_PERF_DETAILS_REQUEST,
    getCandidateJobPreferencesSaga,
  );
  yield takeLatest(
    SAVE_JOB_PERF_DETAILS_REQUEST,
    saveCandidateJobPreferencesSaga,
  );
  yield takeLatest( GET_DEGREE_TYPE_DROPDOWN_DETAILS_REQUEST, degreeTypeDropdownSaga);

  yield takeLatest(GET_DOC_DETAILS_REQUEST, getDocInfoSaga);
  yield takeLatest(SAVE_DOC_DETAILS_REQUEST, saveDocInfoSaga);
  yield takeLatest(
    GET_NON_HOSPITAL_DROPDOWN_REQUEST,
    nonHospitalRolesDropdownSaga,
  );
  yield takeLatest(GET_ACCOMPLISHMENTS_DETAILS_REQUEST, getAccomplishInfoSaga);
  yield takeLatest(
    SAVE_ACCOMPLISHMENTS_DETAILS_REQUEST,
    saveAccomplishInfoSaga,
  );
  yield takeLatest(GET_EDUCATION_DETAILS_REQUEST, getEducationInfoSaga);
  yield takeLatest(SAVE_EDUCATION_DETAILS_REQUEST, saveEducationInfoSaga);

  yield takeLatest(GET_LANGAUGE_DROPDOWN_DETAILS_REQUEST, languageDropdownSaga);
  yield takeLatest(
    GET_CANDIDATE_INFO_DETAILS_REQUEST,
    getCandidatePersonalInfoSaga,
  );
  yield takeLatest(
    SAVE_CANDIDATE_INFO_DETAILS_REQUEST,
    saveCandidatePersonalInfoSaga,
  );
  yield takeLatest(
    SAVE_CANDIDATE_ADDRESS_DETAILS_REQUEST,
    saveCandidateAddressInfoSaga,
  );
  yield takeLatest(
    GET_CANDIDATE_ADDRESS_DETAILS_REQUEST,
    getCandidateAddressInfoSaga,
  );

  yield takeLatest(
    SAVE_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST,
    saveCandidateKeySkillsInfoSaga,
  );
  yield takeLatest(
    GET_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST,
    getCandidateKeySkillsInfoSaga,
  );
  yield takeLatest(
    SAVE_CANDIDATE_LISINCE_DETAILS_REQUEST,
    saveCandidateCertificationInfoSaga,
  );

  yield takeLatest(
    GET_CANDIDATE_LISINCE_DETAILS_REQUEST,
    getCandidateCertificationInfoSaga,
  );

  yield takeLatest(GET_CANDIDATE_SIDE_BAR_REQUEST, getCandidateSideBarSaga);
}
